import Footer from "../components/footer";
import Header from "../components/header";
import SeoLinksSection from "../components/SeoLinksSection";

export default function Home2() {
  return (
    <>
      <Header />
      <>
        {/* banner starts */}
        <section className="banner overflow-hidden">
          <div className="slider top50">
            <div className="swiper-container">
              <div className="swiper-wrapper">
                <div className="swiper-slide">
                  <div className="slide-inner">
                    <div
                      className="slide-image"
                      style={{ backgroundImage: "url(images/slider/1.jpg)" }}
                    />
                    <div className="swiper-content">
                      <div className="entry-meta mb-2">
                        <h5 className="entry-category mb-0 white">
                          Amazing Places
                        </h5>
                      </div>
                      <h1 className="mb-2">
                        <a href="tour-single.html" className="white">
                          Make Your Trip Fun &amp; Noted
                        </a>
                      </h1>
                      <p className="white mb-4">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                        sed do eiusmod tempor incididunt ut labore et dolore
                        magna aliqua
                      </p>
                      <a href="tour-single.html" className="nir-btn">
                        Discover More
                      </a>
                    </div>
                    <div className="dot-overlay" />
                  </div>
                </div>
                <div className="swiper-slide">
                  <div className="slide-inner">
                    <div
                      className="slide-image"
                      style={{ backgroundImage: "url(images/slider/2.jpg)" }}
                    />
                    <div className="swiper-content">
                      <div className="entry-meta mb-2">
                        <h5 className="entry-category mb-0 white">
                          Explore Travel
                        </h5>
                      </div>
                      <h1 className="mb-2">
                        <a href="tour-single.html" className="white">
                          Start Planning Your Dream Trip
                        </a>
                      </h1>
                      <p className="white mb-4">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                        sed do eiusmod tempor incididunt ut labore et dolore
                        magna aliqua
                      </p>
                      <div className="slider-button d-flex justify-content-center">
                        <a href="tour-single1.html" className="nir-btn me-4">
                          Read More
                        </a>
                        <a href="tour-single.html" className="nir-btn-black">
                          Contact Us
                        </a>
                      </div>
                    </div>
                    <div className="dot-overlay" />
                  </div>
                </div>
                <div className="swiper-slide">
                  <div className="slide-inner">
                    <div
                      className="slide-image"
                      style={{ backgroundImage: "url(images/slider/3.jpg)" }}
                    />
                    <div className="swiper-content">
                      <div className="entry-meta mb-2">
                        <h5 className="entry-category mb-0 white">
                          Road To Travel
                        </h5>
                      </div>
                      <h1 className="mb-2">
                        <a href="tour-single.html" className="white">
                          Begin your adventure with us
                        </a>
                      </h1>
                      <p className="white mb-4">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                        sed do eiusmod tempor incididunt ut labore et dolore
                        magna aliqua
                      </p>
                      <a href="tour-single.html" className="nir-btn">
                        Make An Enquiry
                      </a>
                    </div>
                    <div className="dot-overlay" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Add Arrows */}
          <div className="swiper-button-next" />
          <div className="swiper-button-prev" />
        </section>
        {/* banner ends */}
        {/* form main starts */}
        <div className="form-main">
          <div
            className="section-shape top-0"
            style={{ backgroundImage: "url(images/shape-pat.png)" }}
          />
          <div className="container">
            <div className="row align-items-center form-content rounded position-relative ms-5 me-5">
              <div className="col-lg-2 p-0">
                <h4 className="form-title form-title1 text-center p-4 py-5 white bg-theme mb-0 rounded-start d-lg-flex align-items-center">
                  <i className="icon-location-pin fs-1 me-1" /> Find Your
                  Holidays
                </h4>
              </div>
              <div className="col-lg-10 px-4">
                <div className="form-content-in d-lg-flex align-items-center">
                  <div className="form-group me-2">
                    <div className="input-box">
                      <select className="niceSelect">
                        <option value={1}>Destination</option>
                        <option value={2}>Argentina</option>
                        <option value={3}>Belgium</option>
                        <option value={4}>Canada</option>
                        <option value={5}>Denmark</option>
                      </select>
                    </div>
                  </div>
                  <div className="form-group me-2">
                    <div className="input-box">
                      <input type="date" name="date" />
                    </div>
                  </div>
                  <div className="form-group me-2">
                    <div className="input-box">
                      <select className="niceSelect">
                        <option value={1}>Travel Type</option>
                        <option value={2}>City Tour</option>
                        <option value={3}>Family Tour</option>
                      </select>
                    </div>
                  </div>
                  <div className="form-group me-2">
                    <div className="input-box">
                      <select className="niceSelect">
                        <option value={1}>Tour Duration</option>
                        <option value={2}>5 days</option>
                        <option value={3}>7 Days</option>
                      </select>
                    </div>
                  </div>
                  <div className="form-group mb-0 text-center">
                    <a href="#" className="nir-btn w-100">
                      <i className="fa fa-search mr-2" /> Search Now
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* form main ends */}
        {/* about-us starts */}
        <section
          className="about-us pb-6 pt-10"
          style={{
            backgroundImage: "url(images/shape4.png)",
            backgroundPosition: "center",
          }}
        >
          <div className="container">
            <div className="section-title mb-6 w-50 mx-auto text-center">
              <h4 className="mb-1 theme1">Core Features</h4>
              <h2 className="mb-1">
                Find <span className="theme">Travel Perfection</span>
              </h2>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore.
              </p>
            </div>
            {/* why us starts */}
            <div className="why-us">
              <div className="why-us-box">
                <div className="row">
                  <div className="col-lg-3 col-md-6 col-sm-6 mb-4">
                    <div className="why-us-item p-5 pt-6 pb-6 border rounded bg-white">
                      <div className="why-us-content">
                        <div className="why-us-icon mb-1">
                          <i className="icon-flag theme" />
                        </div>
                        <h4>
                          <a href="about.html">Tell Us What You want To Do</a>
                        </h4>
                        <p className="mb-2">
                          Excepteur sint occaecat cupidatat non proident, sunt
                          in culpa qui officia.
                        </p>
                        <p className="mb-0 theme">100+ Reviews</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-6 mb-4">
                    <div className="why-us-item p-5 pt-6 pb-6 border rounded bg-white">
                      <div className="why-us-content">
                        <div className="why-us-icon mb-1">
                          <i className="icon-location-pin theme" />
                        </div>
                        <h4>
                          <a href="about.html">Share Your Travel Locations</a>
                        </h4>
                        <p className="mb-2">
                          Excepteur sint occaecat cupidatat non proident, sunt
                          in culpa qui officia.
                        </p>
                        <p className="mb-0 theme">100+ Reviews</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-6 mb-4">
                    <div className="why-us-item p-5 pt-6 pb-6 border rounded bg-white">
                      <div className="why-us-content">
                        <div className="why-us-icon mb-1">
                          <i className="icon-directions theme" />
                        </div>
                        <h4>
                          <a href="about.html">Share Your Travel Preference</a>
                        </h4>
                        <p className="mb-2">
                          Excepteur sint occaecat cupidatat non proident, sunt
                          in culpa qui officia.
                        </p>
                        <p className="mb-0 theme">100+ Reviews</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-6 mb-4">
                    <div className="why-us-item p-5 pt-6 pb-6 border rounded bg-white">
                      <div className="why-us-content">
                        <div className="why-us-icon mb-1">
                          <i className="icon-compass theme" />
                        </div>
                        <h4>
                          <a href="about.html">Here 100% Trusted Tour Agency</a>
                        </h4>
                        <p className="mb-2">
                          Excepteur sint occaecat cupidatat non proident, sunt
                          in culpa qui officia.
                        </p>
                        <p className="mb-0 theme">100+ Reviews</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* why us ends */}
          </div>
          <div className="white-overlay" />
        </section>
        {/* about-us ends */}
        {/* top Destination starts */}
        <section className="trending pb-3 pt-0">
          <div className="container">
            <div className="section-title mb-6 w-50 mx-auto text-center">
              <h4 className="mb-1 theme1">Top Destinations</h4>
              <h2 className="mb-1">
                Explore <span className="theme">Top Destinations</span>
              </h2>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore.
              </p>
            </div>
            <div className="row align-items-center">
              <div className="col-lg-7">
                <div className="row">
                  <div className="col-lg-12 mb-4">
                    <div className="trend-item1">
                      <div className="trend-image position-relative rounded">
                        <img
                          src="images/destination/destination2.jpg"
                          alt="image"
                        />
                        <div className="trend-content d-flex align-items-center justify-content-between position-absolute bottom-0 p-4 w-100 z-index">
                          <div className="trend-content-title">
                            <h5 className="mb-0">
                              <a href="tour-grid.html" className="theme1">
                                Italy
                              </a>
                            </h5>
                            <h3 className="mb-0 white">Caspian Valley</h3>
                          </div>
                          <span className="white bg-theme p-1 px-2 rounded">
                            18 Tours
                          </span>
                        </div>
                        <div className="color-overlay" />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-6 mb-4">
                    <div className="trend-item1">
                      <div className="trend-image position-relative rounded">
                        <img
                          src="images/destination/destination15.jpg"
                          alt="image"
                        />
                        <div className="trend-content d-flex align-items-center justify-content-between position-absolute bottom-0 p-4 w-100">
                          <div className="trend-content-title">
                            <h5 className="mb-0">
                              <a href="tour-grid.html" className="theme1">
                                Moscow
                              </a>
                            </h5>
                            <h3 className="mb-0 white">Russia</h3>
                          </div>
                          <span className="white bg-theme p-1 px-2 rounded">
                            15 Tours
                          </span>
                        </div>
                        <div className="color-overlay" />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-6 mb-4">
                    <div className="trend-item1">
                      <div className="trend-image position-relative rounded">
                        <img
                          src="images/destination/destination16.jpg"
                          alt="image"
                        />
                        <div className="trend-content d-flex align-items-center justify-content-between position-absolute bottom-0 p-4 w-100 z-index">
                          <div className="trend-content-title">
                            <h5 className="mb-0">
                              <a href="tour-grid.html" className="theme1">
                                Florida
                              </a>
                            </h5>
                            <h3 className="mb-0 white">America</h3>
                          </div>
                          <span className="white bg-theme p-1 px-2 rounded">
                            32 Tours
                          </span>
                        </div>
                        <div className="color-overlay" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-5 mb-4">
                <div className="trend-item1">
                  <div className="trend-image position-relative rounded">
                    <img
                      src="images/destination/destination1.jpg"
                      alt="image"
                    />
                    <div className="trend-content d-flex align-items-center justify-content-between position-absolute bottom-0 p-4 w-100 z-index">
                      <div className="trend-content-title">
                        <h5 className="mb-0">
                          <a href="tour-grid.html" className="theme1">
                            England
                          </a>
                        </h5>
                        <h3 className="mb-0 white">London</h3>
                      </div>
                      <span className="white bg-theme p-1 px-2 rounded">
                        15 Tours
                      </span>
                    </div>
                    <div className="color-overlay" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* top Destination ends */}
        {/* best tour Starts */}
        <section className="trending bg-grey pt-17 pb-6">
          <div
            className="section-shape top-0"
            style={{ backgroundImage: "url(images/shape8.png)" }}
          />
          <div className="container">
            <div className="row align-items-center justify-content-between mb-6">
              <div className="col-lg-7">
                <div className="section-title text-center text-lg-start">
                  <h4 className="mb-1 theme1">Top Pick</h4>
                  <h2 className="mb-1">
                    Best <span className="theme">Tour Packages</span>
                  </h2>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore.
                  </p>
                </div>
              </div>
              <div className="col-lg-5" />
            </div>
            <div className="trend-box">
              <div className="row item-slider">
                <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                  <div className="trend-item rounded box-shadow bg-white">
                    <div className="trend-image position-relative">
                      <img
                        src="images/trending/trending2.jpg"
                        alt="image"
                        className=""
                      />
                      <div className="color-overlay" />
                    </div>
                    <div className="trend-content p-4 pt-5 position-relative">
                      <div className="trend-meta bg-theme white px-3 py-2 rounded">
                        <div className="entry-author">
                          <i className="icon-calendar" />
                          <span className="fw-bold"> 9 Days Tours</span>
                        </div>
                      </div>
                      <h5 className="theme mb-1">
                        <i className="flaticon-location-pin" /> Croatia
                      </h5>
                      <h3 className="mb-1">
                        <a href="tour-grid.html">Piazza Castello</a>
                      </h3>
                      <div className="rating-main d-flex align-items-center pb-2">
                        <div className="rating">
                          <span className="fa fa-star checked" />
                          <span className="fa fa-star checked" />
                          <span className="fa fa-star checked" />
                          <span className="fa fa-star checked" />
                          <span className="fa fa-star checked" />
                        </div>
                        <span className="ms-2">(12)</span>
                      </div>
                      <p className="border-b pb-2 mb-2">
                        Duis aute irure dolor in reprehenderit in voluptate
                        velit esse cillum
                      </p>
                      <div className="entry-meta">
                        <div className="entry-author d-flex align-items-center">
                          <p className="mb-0">
                            <span className="theme fw-bold fs-5"> $170.00</span>{" "}
                            | Per person
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                  <div className="trend-item box-shadow rounded bg-white">
                    <div className="trend-image position-relative">
                      <img src="images/trending/trending3.jpg" alt="image" />
                      <div className="color-overlay" />
                    </div>
                    <div className="trend-content p-4 pt-5 position-relative">
                      <div className="trend-meta bg-theme white px-3 py-2 rounded">
                        <div className="entry-author">
                          <i className="icon-calendar" />
                          <span className="fw-bold"> 9 Days Tours</span>
                        </div>
                      </div>
                      <h5 className="theme mb-1">
                        <i className="flaticon-location-pin" /> Greece
                      </h5>
                      <h3 className="mb-1">
                        <a href="tour-grid.html">Santorini, Oia</a>
                      </h3>
                      <div className="rating-main d-flex align-items-center pb-2">
                        <div className="rating">
                          <span className="fa fa-star checked" />
                          <span className="fa fa-star checked" />
                          <span className="fa fa-star checked" />
                          <span className="fa fa-star checked" />
                          <span className="fa fa-star checked" />
                        </div>
                        <span className="ms-2">(38)</span>
                      </div>
                      <p className="border-b pb-2 mb-2">
                        Duis aute irure dolor in reprehenderit in voluptate
                        velit esse cillum
                      </p>
                      <div className="entry-meta">
                        <div className="entry-author d-flex align-items-center">
                          <p className="mb-0">
                            <span className="theme fw-bold fs-5"> $180.00</span>{" "}
                            | Per person
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                  <div className="trend-item box-shadow rounded bg-white">
                    <div className="trend-image position-relative">
                      <img src="images/trending/trending4.jpg" alt="image" />
                      <div className="color-overlay" />
                    </div>
                    <div className="trend-content p-4 pt-5 position-relative">
                      <div className="trend-meta bg-theme white px-3 py-2 rounded">
                        <div className="entry-author">
                          <i className="icon-calendar" />
                          <span className="fw-bold"> 9 Days Tours</span>
                        </div>
                      </div>
                      <h5 className="theme mb-1">
                        <i className="flaticon-location-pin" /> Maldives
                      </h5>
                      <h3 className="mb-1">
                        <a href="tour-grid.html">Hurawalhi Island</a>
                      </h3>
                      <div className="rating-main d-flex align-items-center pb-2">
                        <div className="rating">
                          <span className="fa fa-star checked" />
                          <span className="fa fa-star checked" />
                          <span className="fa fa-star checked" />
                          <span className="fa fa-star checked" />
                          <span className="fa fa-star checked" />
                        </div>
                        <span className="ms-2">(18)</span>
                      </div>
                      <p className="border-b pb-2 mb-2">
                        Duis aute irure dolor in reprehenderit in voluptate
                        velit esse cillum
                      </p>
                      <div className="entry-meta">
                        <div className="entry-author d-flex align-items-center">
                          <p className="mb-0">
                            <span className="theme fw-bold fs-5"> $260.00</span>{" "}
                            | Per person
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                  <div className="trend-item box-shadow rounded bg-white">
                    <div className="trend-image position-relative">
                      <img src="images/trending/trending1.jpg" alt="image" />
                      <div className="color-overlay" />
                    </div>
                    <div className="trend-content p-4 pt-5 position-relative">
                      <div className="trend-meta bg-theme white px-3 py-2 rounded">
                        <div className="entry-author">
                          <i className="icon-calendar" />
                          <span className="fw-bold"> 5 Days Tours</span>
                        </div>
                      </div>
                      <h5 className="theme mb-1">
                        <i className="flaticon-location-pin" /> Greece
                      </h5>
                      <h3 className="mb-1">
                        <a href="tour-grid.html">Santorini, Oia</a>
                      </h3>
                      <div className="rating-main d-flex align-items-center pb-2">
                        <div className="rating">
                          <span className="fa fa-star checked" />
                          <span className="fa fa-star checked" />
                          <span className="fa fa-star checked" />
                          <span className="fa fa-star checked" />
                          <span className="fa fa-star checked" />
                        </div>
                        <span className="ms-2">(38)</span>
                      </div>
                      <p className="border-b pb-2 mb-2">
                        Duis aute irure dolor in reprehenderit in voluptate
                        velit esse cillum
                      </p>
                      <div className="entry-meta">
                        <div className="entry-author d-flex align-items-center">
                          <p className="mb-0">
                            <span className="theme fw-bold fs-5"> $180.00</span>{" "}
                            | Per person
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="category-main-inner">
              <div className="row align-items-center">
                <div className="col-lg-2">
                  <h3 className="mb-0 white bg-theme p-3 py-5 text-center rounded my-4">
                    Top Categories
                  </h3>
                </div>
                <div className="col-lg-10">
                  <div className="row side-slider">
                    <div className="col-lg-3 col-md-6 my-4">
                      <div className="category-item box-shadow p-2 py-4 text-center bg-white rounded overflow-hidden">
                        <div className="trending-topic-content">
                          <img
                            src="images/icons/004-camping-tent.png"
                            className="mb-1 d-inline-block"
                            alt=""
                          />
                          <h4 className="mb-0">
                            <a href="tour-grid.html">Camping</a>
                          </h4>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6 my-4">
                      <div className="category-item box-shadow p-2 py-4 text-center bg-white rounded overflow-hidden">
                        <div className="trending-topic-content text-center">
                          <img
                            src="images/icons/003-hiking.png"
                            className="mb-1 d-inline-block"
                            alt=""
                          />
                          <h4 className="mb-0">
                            <a href="tour-grid.html">Hiking</a>
                          </h4>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6 my-4">
                      <div className="category-item box-shadow p-2 py-4 text-center bg-white rounded overflow-hidden">
                        <div className="trending-topic-content">
                          <img
                            src="images/icons/005-sunbed.png"
                            className="mb-1 d-inline-block"
                            alt=""
                          />
                          <h4 className="mb-0">
                            <a href="tour-grid.html">Beach Tours</a>
                          </h4>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6 my-4">
                      <div className="category-item box-shadow p-2 py-4 text-center bg-white rounded overflow-hidden">
                        <div className="trending-topic-content">
                          <img
                            src="images/icons/006-surf.png"
                            className="mb-1 d-inline-block"
                            alt=""
                          />
                          <h4 className="mb-0">
                            <a href="tour-grid.html">Surfing</a>
                          </h4>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6 my-4">
                      <div className="category-item box-shadow p2 py-4 text-center bg-white rounded overflow-hidden">
                        <div className="trending-topic-content">
                          <img
                            src="images/icons/002-safari.png"
                            className="mb-1 d-inline-block"
                            alt=""
                          />
                          <h4 className="mb-0">
                            <a href="tour-grid.html">Safari</a>
                          </h4>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6 my-4">
                      <div className="category-item box-shadow p-2 py-4 text-center bg-white rounded overflow-hidden">
                        <div className="trending-topic-content">
                          <img
                            src="images/icons/008-cycling.png"
                            className="mb-1 d-inline-block"
                            alt=""
                          />
                          <h4 className="mb-0">
                            <a href="tour-grid.html">Cycling</a>
                          </h4>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6 my-4">
                      <div className="category-item box-shadow p2 py-4 text-center bg-white rounded overflow-hidden">
                        <img
                          src="images/icons/007-hiking-1.png"
                          className="mb-1 d-inline-block"
                          alt=""
                        />
                        <div className="trending-topic-content">
                          <h4 className="mb-0">
                            <a href="tour-grid.html">Trekings</a>
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* best tour Ends */}
        {/* Last Minute Deal Starts */}
        <section className="trending pb-9">
          <div className="container">
            <div className="section-title mb-6 w-75 mx-auto text-center">
              <h4 className="mb-1 theme1">Top Deals</h4>
              <h2 className="mb-1">
                The Last <span className="theme">Minute Deals</span>
              </h2>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore.
              </p>
            </div>
            <div className="trend-box">
              <div className="row">
                <div className="col-lg-4 mb-4">
                  <div className="trend-item1 rounded box-shadow bg-white">
                    <div className="trend-image position-relative">
                      <img
                        src="images/destination/destination11.jpg"
                        alt="image"
                        className=""
                      />
                      <div className="trend-content1 p-4">
                        <h5 className="theme1 mb-1">
                          <i className="flaticon-location-pin" /> Norway
                        </h5>
                        <h3 className="mb-1 white">
                          <a href="tour-grid.html" className="white">
                            Norway Lake
                          </a>
                        </h3>
                        <div className="rating-main d-flex align-items-center pb-2">
                          <div className="rating">
                            <span className="fa fa-star checked" />
                            <span className="fa fa-star checked" />
                            <span className="fa fa-star checked" />
                            <span className="fa fa-star checked" />
                            <span className="fa fa-star checked" />
                          </div>
                          <span className="ms-2 white">(16)</span>
                        </div>
                        <div className="entry-meta d-flex align-items-center justify-content-between">
                          <div className="entry-author d-flex align-items-center">
                            <p className="mb-0 white">
                              <span className="theme1 fw-bold fs-5">
                                {" "}
                                $180.00
                              </span>{" "}
                              | Per person
                            </p>
                          </div>
                          <div className="entry-author">
                            <i className="icon-calendar white" />
                            <span className="fw-bold white"> 6 Days Tours</span>
                          </div>
                        </div>
                      </div>
                      <div className="overlay" />
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 mb-4">
                  <div className="trend-item1 rounded box-shadow">
                    <div className="trend-image position-relative">
                      <img
                        src="images/destination/destination10.jpg"
                        alt="image"
                        className=""
                      />
                      <div className="trend-content1 p-4">
                        <h5 className="theme1 mb-1">
                          <i className="flaticon-location-pin" /> Usa
                        </h5>
                        <h3 className="mb-1 white">
                          <a href="tour-grid.html" className="white">
                            New York City
                          </a>
                        </h3>
                        <div className="rating-main d-flex align-items-center pb-2">
                          <div className="rating">
                            <span className="fa fa-star checked" />
                            <span className="fa fa-star checked" />
                            <span className="fa fa-star checked" />
                            <span className="fa fa-star checked" />
                            <span className="fa fa-star checked" />
                          </div>
                          <span className="ms-2 white">(12)</span>
                        </div>
                        <div className="entry-meta d-flex align-items-center justify-content-between">
                          <div className="entry-author d-flex align-items-center">
                            <p className="mb-0 white">
                              <span className="theme1 fw-bold fs-5">
                                {" "}
                                $140.00
                              </span>{" "}
                              | Per person
                            </p>
                          </div>
                          <div className="entry-author">
                            <i className="icon-calendar white" />
                            <span className="fw-bold white"> 3 Days Tours</span>
                          </div>
                        </div>
                      </div>
                      <div className="overlay" />
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 mb-4">
                  <div className="trend-item1 rounded box-shadow">
                    <div className="trend-image position-relative">
                      <img
                        src="images/destination/destination13.jpg"
                        alt="image"
                        className=""
                      />
                      <div className="trend-content1 p-4">
                        <h5 className="theme1 mb-1">
                          <i className="flaticon-location-pin" /> Maldives
                        </h5>
                        <h3 className="mb-1 white">
                          <a href="tour-grid.html" className="white">
                            Male City
                          </a>
                        </h3>
                        <div className="rating-main d-flex align-items-center pb-2">
                          <div className="rating">
                            <span className="fa fa-star checked" />
                            <span className="fa fa-star checked" />
                            <span className="fa fa-star checked" />
                            <span className="fa fa-star checked" />
                            <span className="fa fa-star checked" />
                          </div>
                          <span className="ms-2 white">(12)</span>
                        </div>
                        <div className="entry-meta d-flex align-items-center justify-content-between">
                          <div className="entry-author d-flex align-items-center">
                            <p className="mb-0 white">
                              <span className="theme1 fw-bold fs-5">
                                {" "}
                                $140.00
                              </span>{" "}
                              | Per person
                            </p>
                          </div>
                          <div className="entry-author">
                            <i className="icon-calendar white" />
                            <span className="fw-bold white"> 3 Days Tours</span>
                          </div>
                        </div>
                      </div>
                      <div className="overlay" />
                    </div>
                  </div>
                </div>
                <div className="col-lg-12 text-center">
                  <a href="tour-grid.html" className="nir-btn">
                    View All Deals
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Last Minute Deal Ends */}
        {/* testimonial starts */}
        <section
          className="testimonial pt-10 pb-20"
          style={{ backgroundImage: "url(images/bg/bg1.jpg)" }}
        >
          <div className="container">
            <div className="testimonial-in">
              <div className="row align-items-center">
                <div className="col-lg-5">
                  <div className="section-title">
                    <h4 className="mb-1 theme1">Our Testimonails</h4>
                    <h2 className="mb-1 white">
                      Good Reviews By <span className="theme">Clients</span>
                    </h2>
                    <p className="mb-0 white">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do eiusmod tempor incididunt ut labore.
                    </p>
                  </div>
                </div>
                <div className="col-lg-7">
                  <div className="row about-slider">
                    <div className="col-sm-4 item">
                      <div className="testimonial-item1">
                        <div className="details d-flex">
                          <i className="fa fa-quote-left fs-1 mb-0" />
                          <div className="author-content ms-4">
                            <p className="mb-4 white fs-5 fw-normal">
                              Lorem Ipsum is simply dummy text of the printing
                              andypesetting industry. Lorem ipsum a simple Lorem
                              Ipsum has been the industry's standard dummy hic
                              et quidem. Dignissimos maxime velit unde inventore
                              quasi vero dolorem.
                            </p>
                            <div className="author-info d-flex align-items-center">
                              <img src="images/testimonial/img1.jpg" alt="" />
                              <div className="author-title ms-3">
                                <h5 className="m-0 theme1">Lonell South</h5>
                                <span className="white">Accountant</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-4 item">
                      <div className="testimonial-item1">
                        <div className="details d-flex">
                          <i className="fa fa-quote-left fs-1 mb-0" />
                          <div className="author-content ms-4">
                            <p className="mb-4 white fs-5 fw-normal">
                              Lorem Ipsum is simply dummy text of the printing
                              andypesetting industry. Lorem ipsum a simple Lorem
                              Ipsum has been the industry's standard dummy hic
                              et quidem. Dignissimos maxime velit unde inventore
                              quasi vero dolorem.
                            </p>
                            <div className="author-info d-flex align-items-center">
                              <img src="images/testimonial/img2.jpg" alt="" />
                              <div className="author-title ms-3">
                                <h5 className="m-0 theme1">Kelton Mick</h5>
                                <span className="white">Manager</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-4 item">
                      <div className="testimonial-item1">
                        <div className="details d-flex">
                          <i className="fa fa-quote-left fs-1 mb-0" />
                          <div className="author-content ms-4">
                            <p className="mb-4 white fs-5 fw-normal">
                              Lorem Ipsum is simply dummy text of the printing
                              andypesetting industry. Lorem ipsum a simple Lorem
                              Ipsum has been the industry's standard dummy hic
                              et quidem. Dignissimos maxime velit unde inventore
                              quasi vero dolorem.
                            </p>
                            <div className="author-info d-flex align-items-center">
                              <img src="images/testimonial/img3.jpg" alt="" />
                              <div className="author-title ms-3">
                                <h5 className="m-0 theme1">Jared Erondu</h5>
                                <span className="white">Supervisor</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="dot-overlay" />
        </section>
        {/* testimonial Ends */}
        {/* offer Packages Starts */}
        <section className="trending trend-packages pt-0 pb-0 z-index3">
          <div className="container">
            <div className="trend-box mt-minus">
              <div className="row review-slider1 mx-0">
                <div className="col-lg-6 px-2">
                  <div className="trend-full bg-white rounded box-shadow overflow-hidden">
                    <div className="row m-0">
                      <div className="col-lg-5 col-md-4 ps-md-0">
                        <div className="trend-item2">
                          <a
                            href="tour-list.html"
                            style={{
                              backgroundImage:
                                "url(images/trending/trending1.jpg)",
                            }}
                          />
                          <div className="ribbon ribbon-top-left">
                            <span className="fw-bold">20% OFF</span>
                          </div>
                          <div className="color-overlay" />
                        </div>
                      </div>
                      <div className="col-lg-7 col-md-8">
                        <div className="trend-content py-3 position-relative">
                          <h5 className="theme mb-1">
                            <i className="flaticon-location-pin" /> Croatia
                          </h5>
                          <h3 className="mb-1">
                            <a href="tour-grid.html">Piazza Castello</a>
                          </h3>
                          <div className="rating-main d-flex align-items-center pb-2">
                            <div className="rating">
                              <span className="fa fa-star checked" />
                              <span className="fa fa-star checked" />
                              <span className="fa fa-star checked" />
                              <span className="fa fa-star checked" />
                              <span className="fa fa-star checked" />
                            </div>
                            <span className="ms-2">(12)</span>
                          </div>
                          <p>
                            Duis aute irure dolor in reprehenderit in voluptate
                            velit esse cillum
                          </p>
                          <div className="trend-meta border-b pb-2 mb-2">
                            <div className="entry-author theme">
                              <i className="icon-calendar" />
                              <span> 9 Days Tours</span>
                            </div>
                          </div>
                          <div className="entry-meta">
                            <div className="entry-author d-flex align-items-center">
                              <p className="mb-0">
                                <span className="theme fw-bold fs-5">
                                  {" "}
                                  $170.00
                                </span>{" "}
                                | Per person
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 px-2">
                  <div className="trend-full bg-white rounded box-shadow overflow-hidden">
                    <div className="row m-0">
                      <div className="col-lg-5 col-md-4 ps-md-0">
                        <div className="trend-item2">
                          <a
                            href="tour-list.html"
                            style={{
                              backgroundImage:
                                "url(images/trending/trending2.jpg)",
                            }}
                          />
                          <div className="ribbon ribbon-top-left">
                            <span className="fw-bold">10% OFF</span>
                          </div>
                          <div className="color-overlay" />
                        </div>
                      </div>
                      <div className="col-lg-7 col-md-8">
                        <div className="trend-content py-3 position-relative">
                          <h5 className="theme mb-1">
                            <i className="flaticon-location-pin" /> Greece
                          </h5>
                          <h3 className="mb-1">
                            <a href="tour-grid.html">Santorini, Oia</a>
                          </h3>
                          <div className="rating-main d-flex align-items-center pb-2">
                            <div className="rating">
                              <span className="fa fa-star checked" />
                              <span className="fa fa-star checked" />
                              <span className="fa fa-star checked" />
                              <span className="fa fa-star checked" />
                              <span className="fa fa-star checked" />
                            </div>
                            <span className="ms-2">(18)</span>
                          </div>
                          <p>
                            Duis aute irure dolor in reprehenderit in voluptate
                            velit esse cillum
                          </p>
                          <div className="trend-meta border-b pb-2 mb-2">
                            <div className="entry-author theme">
                              <i className="icon-calendar" />
                              <span> 7 Days Tours</span>
                            </div>
                          </div>
                          <div className="entry-meta">
                            <div className="entry-author d-flex align-items-center">
                              <p className="mb-0">
                                <span className="theme fw-bold fs-5">
                                  {" "}
                                  $210.00
                                </span>{" "}
                                | Per person
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 px-2">
                  <div className="trend-full bg-white rounded box-shadow overflow-hidden">
                    <div className="row m-0">
                      <div className="col-lg-5 col-md-4 ps-md-0">
                        <div className="trend-item2">
                          <a
                            href="tour-list.html"
                            style={{
                              backgroundImage:
                                "url(images/trending/trending3.jpg)",
                            }}
                          />
                          <div className="ribbon ribbon-top-left">
                            <span className="fw-bold">30% OFF</span>
                          </div>
                          <div className="color-overlay" />
                        </div>
                      </div>
                      <div className="col-lg-7 col-md-8">
                        <div className="trend-content py-3 position-relative">
                          <h5 className="theme mb-1">
                            <i className="flaticon-location-pin" /> Norway
                          </h5>
                          <h3 className="mb-1">
                            <a href="tour-grid.html">Norway Lake</a>
                          </h3>
                          <div className="rating-main d-flex align-items-center pb-2">
                            <div className="rating">
                              <span className="fa fa-star checked" />
                              <span className="fa fa-star checked" />
                              <span className="fa fa-star checked" />
                              <span className="fa fa-star checked" />
                              <span className="fa fa-star checked" />
                            </div>
                            <span className="ms-2">(17)</span>
                          </div>
                          <p>
                            Duis aute irure dolor in reprehenderit in voluptate
                            velit esse cillum
                          </p>
                          <div className="trend-meta border-b pb-2 mb-2">
                            <div className="entry-author theme">
                              <i className="icon-calendar" />
                              <span> 6 Days Tours</span>
                            </div>
                          </div>
                          <div className="entry-meta">
                            <div className="entry-author d-flex align-items-center">
                              <p className="mb-0">
                                <span className="theme fw-bold fs-5">
                                  {" "}
                                  $185.00
                                </span>{" "}
                                | Per person
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 px-2">
                  <div className="trend-full bg-white rounded box-shadow overflow-hidden">
                    <div className="row m-0">
                      <div className="col-lg-5 col-md-4 ps-md-0">
                        <div className="trend-item2">
                          <a
                            href="tour-list.html"
                            style={{
                              backgroundImage:
                                "url(images/trending/trending4.jpg)",
                            }}
                          />
                          <div className="ribbon ribbon-top-left">
                            <span className="fw-bold">15% OFF</span>
                          </div>
                          <div className="color-overlay" />
                        </div>
                      </div>
                      <div className="col-lg-7 col-md-8">
                        <div className="trend-content py-3 position-relative">
                          <h5 className="theme mb-1">
                            <i className="flaticon-location-pin" /> Maldives
                          </h5>
                          <h3 className="mb-1">
                            <a href="tour-grid.html">Hurawalhi Island</a>
                          </h3>
                          <div className="rating-main d-flex align-items-center pb-2">
                            <div className="rating">
                              <span className="fa fa-star checked" />
                              <span className="fa fa-star checked" />
                              <span className="fa fa-star checked" />
                              <span className="fa fa-star checked" />
                              <span className="fa fa-star checked" />
                            </div>
                            <span className="ms-2">(32)</span>
                          </div>
                          <p>
                            Duis aute irure dolor in reprehenderit in voluptate
                            velit esse cillum
                          </p>
                          <div className="trend-meta border-b pb-2 mb-2">
                            <div className="entry-author theme">
                              <i className="icon-calendar" />
                              <span> 4 Days Tours</span>
                            </div>
                          </div>
                          <div className="entry-meta">
                            <div className="entry-author d-flex align-items-center">
                              <p className="mb-0">
                                <span className="theme fw-bold fs-5">
                                  {" "}
                                  $260.00
                                </span>{" "}
                                | Per person
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* offer Packages Ends */}
        {/* our teams starts */}
        <section className="our-team pb-0">
          <div className="container">
            <div className="section-title mb-6 w-75 mx-auto text-center">
              <h4 className="mb-1 theme1">Tour Guides</h4>
              <h2 className="mb-1">
                Meet Our <span className="theme">Excellent Guides</span>
              </h2>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore.
              </p>
            </div>
            <div className="team-main">
              <div className="row shop-slider">
                <div className="col-lg-3 col-md-6 col-sm-12 mb-4">
                  <div className="team-list rounded">
                    <div className="team-image">
                      <img src="images/team/img1.jpg" alt="team" />
                    </div>
                    <div className="team-content text-center p-3 bg-theme">
                      <h4 className="mb-0 white">Salmon Thuir</h4>
                      <p className="mb-0 white">Senior Agent</p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-12 mb-4">
                  <div className="team-list rounded">
                    <div className="team-image">
                      <img src="images/team/img2.jpg" alt="team" />
                    </div>
                    <div className="team-content text-center p-3 bg-theme">
                      <h4 className="mb-0 white">Horke Pels</h4>
                      <p className="mb-0 white">Head Officer</p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-12 mb-4">
                  <div className="team-list rounded">
                    <div className="team-image">
                      <img src="images/team/img4.jpg" alt="team" />
                    </div>
                    <div className="team-content text-center p-3 bg-theme">
                      <h4 className="mb-0 white">Solden kalos</h4>
                      <p className="mb-0 white">Supervisor</p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-12 mb-4">
                  <div className="team-list rounded">
                    <div className="team-image">
                      <img src="images/team/img3.jpg" alt="team" />
                    </div>
                    <div className="team-content text-center p-3 bg-theme">
                      <h4 className="mb-0 white">Nelson Bam</h4>
                      <p className="mb-0 white">Quality Assurance</p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-12 mb-4">
                  <div className="team-list rounded">
                    <div className="team-image">
                      <img src="images/team/img4.jpg" alt="team" />
                    </div>
                    <div className="team-content text-center bg-theme p-3">
                      <h4 className="mb-0 white">Cacics Coold</h4>
                      <p className="mb-0 white">Asst. Manager</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* our teams Ends */}
        {/* recent-articles starts */}
        <section className="trending recent-articles pb-6 pt-5">
          <div className="container">
            <div className="section-title mb-6 w-75 mx-auto text-center">
              <h4 className="mb-1 theme1">Our Blogs Offers</h4>
              <h2 className="mb-1">
                Recent <span className="theme">Articles &amp; Posts</span>
              </h2>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore.
              </p>
            </div>
            <div className="recent-articles-inner">
              <div className="row">
                <div className="col-lg-4">
                  <div className="trend-item box-shadow bg-white mb-4 rounded">
                    <div className="trend-image">
                      <img src="images/trending/trending10.jpg" alt="image" />
                    </div>
                    <div className="trend-content-main p-4">
                      <div className="trend-content">
                        <h5 className="theme mb-1">Technology</h5>
                        <h4 className="mb-0">
                          <a href="detail-1.html">
                            How a developer duo at Deutsche Bank keep remote
                            alive.
                          </a>
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="trend-item box-shadow bg-white mb-4 rounded">
                    <div className="trend-image">
                      <img src="images/trending/trending12.jpg" alt="image" />
                    </div>
                    <div className="trend-content-main p-4">
                      <div className="trend-content">
                        <h5 className="theme mb-1">Inspiration</h5>
                        <h4 className="mb-0">
                          <a href="detail-1.html">
                            Inspire Runner with Autism Graces of Women's Running
                          </a>
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="trend-item box-shadow bg-white mb-4 rounded">
                    <div className="trend-image">
                      <img src="images/trending/trending13.jpg" alt="image" />
                    </div>
                    <div className="trend-content-main p-4">
                      <div className="trend-content">
                        <h5 className="theme mb-1">Public</h5>
                        <h4 className="mb-0">
                          <a href="detail-1.html">
                            Services To Grow Your Business Sell Affiliate
                            Products
                          </a>
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* recent-articles ends */}
        {/* partner starts */}
        <section className="our-partner pt-0 pb-5">
          <div className="container">
            <div className="section-title mb-6 w-75 mx-auto text-center">
              <h4 className="mb-1 theme1">Our Partners</h4>
              <h2 className="mb-1">
                Our Awesome <span className="theme">partners</span>
              </h2>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore.
              </p>
            </div>
            <div className="row align-items-center partner-in partner-slider">
              <div className="col-md-3 col-sm-6">
                <div className="partner-item p-4 py-2 rounded bg-lgrey">
                  <img src="images/cl-1.png" alt="" />
                </div>
              </div>
              <div className="col-md-3 col-sm-6">
                <div className="partner-item p-4 py-2 rounded bg-lgrey">
                  <img src="images/cl-5.png" alt="" />
                </div>
              </div>
              <div className="col-md-3 col-sm-6">
                <div className="partner-item p-4 py-2 rounded bg-lgrey">
                  <img src="images/cl-2.png" alt="" />
                </div>
              </div>
              <div className="col-md-3 col-sm-6">
                <div className="partner-item p-4 py-2 rounded bg-lgrey">
                  <img src="images/cl-3.png" alt="" />
                </div>
              </div>
              <div className="col-md-3 col-sm-6">
                <div className="partner-item p-4 py-2 rounded bg-lgrey">
                  <img src="images/cl-4.png" alt="" />
                </div>
              </div>
              <div className="col-md-3 col-sm-6">
                <div className="partner-item p-4 py-2 rounded bg-lgrey">
                  <img src="images/cl-5.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* partner ends */}
      </>

      <SeoLinksSection />
      <Footer />
    </>
  );
}
